import { render, staticRenderFns } from "./lookg.vue?vue&type=template&id=0582b303&scoped=true"
import script from "./lookg.vue?vue&type=script&lang=js"
export * from "./lookg.vue?vue&type=script&lang=js"
import style0 from "./lookg.vue?vue&type=style&index=0&id=0582b303&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0582b303",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0582b303')) {
      api.createRecord('0582b303', component.options)
    } else {
      api.reload('0582b303', component.options)
    }
    module.hot.accept("./lookg.vue?vue&type=template&id=0582b303&scoped=true", function () {
      api.rerender('0582b303', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PPT/lookg.vue"
export default component.exports